var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseMenuIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3719",
    "data-name": "Rectangle 3719",
    width: 20,
    height: 20,
    transform: "translate(337 56)",
    fill: "#012169",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_615",
    "data-name": "Mask Group 615",
    transform: "translate(-337 -56)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "dismiss-circle-24-regular",
    d: "M12,2A10,10,0,1,1,2,12,10,10,0,0,1,12,2Zm0,1.5A8.5,8.5,0,1,0,20.5,12,8.5,8.5,0,0,0,12,3.5Zm3.446,4.9.084.073a.75.75,0,0,1,.073.977l-.073.084L13.061,12l2.469,2.47a.75.75,0,0,1,.073.977l-.073.084a.75.75,0,0,1-.977.073l-.084-.073L12,13.061,9.53,15.53a.75.75,0,0,1-.977.073L8.47,15.53a.75.75,0,0,1-.073-.977l.073-.084L10.939,12,8.47,9.53A.75.75,0,0,1,8.4,8.554L8.47,8.47A.75.75,0,0,1,9.446,8.4l.084.073L12,10.939,14.47,8.47A.75.75,0,0,1,15.446,8.4Z",
    transform: "translate(335 54)",
    fill: "#012169"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseMenuIcon);
export default __webpack_public_path__ + "static/media/close-menu-icon.17a373a11d95f058811ff6fedbd81ac1.svg";
export { ForwardRef as ReactComponent };